import { Box, Tooltip } from '@mui/material';
import { useLocalize } from 'dg-web-shared/lib/Localization.tsx';
import type { Message } from 'dg-web-shared/lib/Localized.ts';

export function LocalizedOverflow(props: Message) {
    const localize = useLocalize();
    const text = localize(props);

    return (
        <Tooltip title={text}>
            <Box
                component="span"
                sx={{
                    display: 'block',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
            >
                {text}
            </Box>
        </Tooltip>
    );
}
